import config from "@shared/config/client";
import { ICallableRequestBuilder } from "../requestBuilder/types";
import queryString from "query-string";
import {
  ART_ORDER_DEFAULT_PAGE,
  ART_ORDER_PAGE_SIZE,
} from "@/app/(components)/Application/ArtOrder/constants";
import { ArtOrderFull } from "../art-order/types";

const getActiveOrders =
  (request: ICallableRequestBuilder<ArtOrderFull[]>) =>
  (
    pageNumber: number = ART_ORDER_DEFAULT_PAGE,
    take: number = ART_ORDER_PAGE_SIZE,
  ) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/art-order/order/list/active`,
      query: {
        skip: (pageNumber - 1) * take,
        take: take,
      },
    });
    return request.call(url);
  };

const getMyOrders =
  (request: ICallableRequestBuilder<ArtOrderFull[]>) =>
  (
    pageNumber: number = ART_ORDER_DEFAULT_PAGE,
    take: number = ART_ORDER_PAGE_SIZE,
  ) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/art-order/order/list/my`,
      query: {
        skip: (pageNumber - 1) * take,
        take: take,
      },
    });
    return request.call(url);
  };

const getOrdersForMyOffers =
  (request: ICallableRequestBuilder<ArtOrderFull[]>) =>
  (
    pageNumber: number = ART_ORDER_DEFAULT_PAGE,
    take: number = ART_ORDER_PAGE_SIZE,
  ) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/art-order/order/list/for-my-offers`,
      query: {
        skip: (pageNumber - 1) * take,
        take: take,
      },
    });
    return request.call(url);
  };

const getActiveOrdersCount =
  (request: ICallableRequestBuilder<number>) => () => {
    return request.call(
      `${config.apiUrl}/art-order/order/list/count/active`,
      (init) => ({
        ...init,
        method: "GET",
      }),
    );
  };

const getMyOrdersCount = (request: ICallableRequestBuilder<number>) => () => {
  return request.call(
    `${config.apiUrl}/art-order/order/list/count/my`,
    (init) => ({
      ...init,
      method: "GET",
    }),
  );
};

const getOrdersForMyOffersCount =
  (request: ICallableRequestBuilder<number>) => () => {
    return request.call(
      `${config.apiUrl}/art-order/order/list/count/for-my-offers`,
      (init) => ({
        ...init,
        method: "GET",
      }),
    );
  };

const requests = {
  getActiveOrders,
  getMyOrders,
  getOrdersForMyOffers,
  getActiveOrdersCount,
  getMyOrdersCount,
  getOrdersForMyOffersCount,
};

export default requests;
